import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useFamiliesChartsDataContext } from './hooks/useFamiliesChartsDataContext';

export const Families = () => {
    const { chartData } = useFamiliesChartsDataContext();


    return (
        <SimpleBars
            title={'Total de Famílias'}
            horizontal={true}
            subtitles={chartData?.families?.map((item) => item.description)}
            values={chartData?.families?.map((item) => item.total  ||  0)}
        />
    );
};
